import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NotasService } from "src/app/features/notas/notas.service";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { NotaOperacaoGarantida } from "src/app/model/nota.model";
import { OperacaoGarantida } from "src/app/model/operacao-garantida.model";
import Utils from "src/app/shared/fgi-utils";
import { FileUtilsService } from "src/app/shared/file-utils.service";
import { DesabilitarNotaPopUpComponent } from "./desabilitar-nota/desabilitar-nota-popup.component";

@Component({
    selector: 'aba-notas',
    templateUrl: 'aba-nota.component.html',
    standalone: false
})
export class AbaNotaComponent implements OnChanges {
    @Input()
    public model: OperacaoGarantida;
    @Input()
    public podeCadastrarNota: Boolean;
    public agentesFinanceiros: AgenteFinanceiro[];

    public notasOperacao: NotaOperacaoGarantida[];


    constructor(
        private notasService: NotasService,
        private modalService: NgbModal,
        private activatedRoute: ActivatedRoute,
        private fileUtilsService: FileUtilsService,
        private router: Router) {
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.notasService.getNotas({ idOperacao: this.model.id }).subscribe(response => {
            this.notasOperacao = response.resultados;
        });
    }

    nomeAgente(cnpj:string){
        return Utils.nomeAgentePorCNPJ(cnpj, this.agentesFinanceiros);
    }

    mudarRota() {
        this.notasService.setOperacao(this.model)
        this.router.navigate(['/notas']);
    }

    editarNota(nota: NotaOperacaoGarantida) {
        this.notasService.setNotaTelaOperacao(nota);
        this.router.navigate(['/notas']);
    }

    desativacaoNota(nota: NotaOperacaoGarantida) {
        const a = this.modalService.open(DesabilitarNotaPopUpComponent, {
            size: 'xl',
            backdrop: 'static'
        });
        a.componentInstance.nota = nota;
        a.componentInstance.agentes = this.agentesFinanceiros;
    }

    exportarAnexoNota(nota: NotaOperacaoGarantida) {
        this.notasService.getAnexo(nota.id).subscribe((conteudo) => {
            this.fileUtilsService.exportarArquivo(nota.nomeAnexo, conteudo, FileUtilsService.APPLICATION_OCTEC);
        });
    }

    reduzirMensagemNota(nota: NotaOperacaoGarantida): string {
        return nota.mensagem.slice(0, 50) + ' ...';
    }

}